import { ImagePlaceholder } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { APP_PROMO_BANNER_ICON } from '../constants';
import type { AppInfoProps } from '../types';
import { AppDescription, AppIcon, AppInfoRoot, AppName, AppNameAndDescription } from './styles';

export const AppInfo: FC<AppInfoProps> = ({ appDescription, appIcon, appName }) => {
  const { getTestId } = useTestId();

  return (
    <AppInfoRoot>
      {appIcon ? (
        <AppIcon
          data-testid={getTestId(APP_PROMO_BANNER_ICON)}
          src={appIcon}
          alt={appName ?? appIcon}
        />
      ) : (
        <ImagePlaceholder
          height={60}
          width={60}
        />
      )}
      <AppNameAndDescription>
        <AppName
          color="textPrimary"
          fontWeight="bold"
        >
          {appName}
        </AppName>
        <AppDescription variant="caption">{appDescription}</AppDescription>
      </AppNameAndDescription>
    </AppInfoRoot>
  );
};
